import * as React from 'react'
import * as ReactDom from 'react-dom'
import { ResourceProvider } from '../../resourceProvider';

export interface IDisclaimerProps {

}

export interface IDisclaimerState {

}

export class Disclaimer extends React.Component<IDisclaimerProps, IDisclaimerState>
{
	constructor(props: IDisclaimerProps) {
		super(props);
	}

	public render(): JSX.Element {
		return (
			<div className="container disclaimer-container">
				<h6>{ResourceProvider.getText('OverviewPage.Disclaimer.Title')}</h6>
				<p className="p4">{ResourceProvider.getText('OverviewPage.Disclaimer.Text')}</p>
			</div>
		);
	}
}